import { FaTrophy, FaMedal } from "react-icons/fa";

export const podiumConfig = [
  {
    place: 2,
    title: "Segundo Lugar",
    icon: FaMedal,
    height: "330px",
    order: 1,
    color: "#6c757d",
    iconSize: 30,
  },
  {
    place: 1,
    title: "Primer Lugar",
    icon: FaTrophy,
    height: "360px",
    order: 2,
    color: "#ffc107",
    iconSize: 48,
  },
  {
    place: 3,
    title: "Tercer Lugar",
    icon: FaMedal,
    height: "300px",
    order: 3,
    color: "#CD7F32",
    iconSize: 30,
  },
];
